import { capitalizeAllIfLower, capitalizeIfLower } from '@btime/helpers'
import { compose, path } from 'ramda'
import { getPriorityColor } from '@btime/constants'
import React from 'react'

import { SmallText, Text } from '../../../../components/presentation/Text'
import { useOpenServiceOrderModal } from '../../../../utils/routes/modals/modalsActions'
import { useServiceOrders } from '../_load/ServiceOrdersLoader'
import FlexGrid, { FlexCol } from '../../../../components/structure/FlexGrid'
import Icon from '../../../../components/shapes/Icon'
import Link from '../../../../components/actions/Link'
import Panel from '../../../../components/structure/Panel'
import Scroll from '../../../../components//helpers/Scroll'
import StatusTag from '../../../../containers/serviceOrders/StatusTag'

const ListItem = ({ item }) => {
  const checklistName = compose(capitalizeIfLower, path(['checklist', 'name']))(item)
  const userName = compose(capitalizeAllIfLower, path(['user', 'name']))(item)
  const placeName = compose(capitalizeAllIfLower, path(['place', 'name']))(item)
  const color = getPriorityColor(path(['priority', 'name'], item))
  const openModal = useOpenServiceOrderModal()

  return (
    <Link block onClick={() => openModal(item)}>
      <Panel smallPadding noMargin lineBorder borderLeftColor={color} width="100%">
        <FlexGrid justify="space-between" gutter={0.3}>
          <FlexCol flex={3}>
            <SmallText size="xxsmall">{item.yearlyId}</SmallText>
            <Text weight={500}>{checklistName}</Text>
          </FlexCol>

          <FlexCol flex={2}>
            <SmallText size="xsmall">{placeName}</SmallText>
          </FlexCol>

          <FlexCol flex={2}>
            <SmallText size="xsmall">{userName}</SmallText>
          </FlexCol>

          <FlexCol flex={1}>
            <StatusTag item={item.serviceStatus} />
          </FlexCol>

          <FlexCol width="2rem">
            <Icon name="BsSearch" size=".8rem" />
          </FlexCol>
        </FlexGrid>
      </Panel>
    </Link>
  )
}

const ChildrenList = () => {
  const children = useServiceOrders()

  return (
    <Scroll overflowX="hidden">
      <FlexGrid direction="column" align="stretch" gutter={0.3}>
        {children.map(item => (
          <ListItem key={item.id} item={item} />
        ))}
      </FlexGrid>
    </Scroll>
  )
}

export default ChildrenList
